import React from 'react'
import TableCellConges from './TableCellConges'

const TableCellCongesRemaining = ({
  item,
  label
}) => {
  return (
    <TableCellConges
      label={label}
      item={item.conges_remaining}
    />
  )
}

export default TableCellCongesRemaining
